export default {
    computed: {
        pageTitle() {
            return ''
        },
        pageDescription() {
            return ''
        },
        pageImage() {
            return ''
        },
        pageMetaDescription() {
            return ''
        },
        pageMetaKeywords() {
            return ''
        },
        pageMetaAuthor() {
            return ''
        },
        pageMetaRobots() {
            return ''
        },
    },

    methods: {
        composeDocumentTitle() {
            document.title = this.pageTitle ? `${this.pageTitle} — ${this.$t('common.app_name')}` : this.$t('common.app_name')
            document.head.querySelector('meta[property="og:title"]').content = this.pageTitle
                ? this.pageTitle
                : this.$t('pages.auth.head.title')
        },
        composeDocumentDescription() {
            document.head.querySelector('meta[property="og:description"]').content = this.pageDescription
                ? this.pageDescription
                : this.$t('pages.auth.head.description')
        },
        composeDocumentImage() {
            document.head.querySelector('meta[property="og:image"]').content = this.pageImage
                ? this.pageImage
                : this.$t('pages.auth.head.image')
        },
        composeMetaDescription() {
            document.head.querySelector('meta[name="description"]').content = this.pageMetaDescription
                ? this.pageMetaDescription
                : this.$t('pages.auth.head.description')
        },
        composeMetaKeywords() {
            document.head.querySelector('meta[name="keywords"]').content = this.pageMetaKeywords
                ? this.pageMetaKeywords
                : this.$t('pages.auth.head.keywords')
        },
        composeMetaAuthor() {
            document.head.querySelector('meta[name="author"]').content = this.pageMetaAuthor
                ? this.pageMetaAuthor
                : this.$t('pages.auth.head.author')
        },
        composeMetaRobots() {
            document.head.querySelector('meta[name="robots"]').content = this.pageMetaRobots
                ? this.pageMetaRobots
                : this.$t('pages.auth.head.robots')
        },
    },

    mounted() {
        this.composeDocumentTitle()
        this.composeDocumentDescription()
        this.composeDocumentImage()
        this.composeMetaDescription()
        this.composeMetaKeywords()
        this.composeMetaAuthor()
        this.composeMetaRobots()
    },

    watch: {
        pageTitle() {
            this.composeDocumentTitle()
        },
        pageDescription() {
            this.composeDocumentDescription()
        },
        pageImage() {
            this.composeDocumentImage()
        },
        pageMetaDescription() {
            this.composeMetaDescription()
        },
        pageMetaKeywords() {
            this.composeMetaKeywords()
        },
        pageMetaAuthor() {
            this.composeMetaAuthor()
        },
        pageMetaRobots() {
            this.composeMetaRobots()
        },
    },
}
